import { useCallback, useSyncExternalStore } from 'react';

const STORAGE_KEY = 'webviewer.inspector.sections';

/* Repli des sections de l'inspecteur, par titre : replier « Style » le replie
   pour toutes les box, et le choix survit au rechargement. Le stockage peut
   être indisponible (navigation privée, données bloquées) : on retombe alors
   sur l'état par défaut, sans rien casser. */
const readStored = () => {
  try {
    return JSON.parse(window.localStorage.getItem(STORAGE_KEY)) || {};
  } catch {
    return {};
  }
};

let collapsedByTitle = readStored();
const listeners = new Set();

const subscribe = (listener) => {
  listeners.add(listener);
  return () => listeners.delete(listener);
};

const setCollapsed = (title, collapsed) => {
  collapsedByTitle = { ...collapsedByTitle, [title]: collapsed };
  try {
    window.localStorage.setItem(STORAGE_KEY, JSON.stringify(collapsedByTitle));
  } catch {
    /* Le repli vaut alors pour la session seulement. */
  }
  listeners.forEach((listener) => listener());
};

/** `[collapsed, toggle]` pour la section `title`. */
export function useInspectorSectionState(title, collapsedByDefault = false) {
  const stored = useSyncExternalStore(subscribe, () => collapsedByTitle[title]);
  const collapsed = stored ?? collapsedByDefault;
  const toggle = useCallback(() => setCollapsed(title, !collapsed), [title, collapsed]);
  return [collapsed, toggle];
}
